/* eslint-disable react-hooks/exhaustive-deps */
import { capitalize } from 'utils/helpers';
import { useDeleteOrderLedgerLink } from 'hooks/ledger/mutations';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import useAlert from 'utils/alert';
import useDeleteLedgerAssociation from 'utils/ledger/use-delete-ledger-association';
import useDeleteEntry from 'utils/ledger/use-delete-ledger-entry';
import { sortedAccounting } from '.';
import { AccountingType } from 'v2-types/order';

const useMutationsAccounting = (setAccounting: (acc: AccountingType[]) => void) => {
  const { t } = useTranslation();
  const showAlert = useAlert();

  const { deleteAssociation, deleteAssociationResponse } = useDeleteLedgerAssociation(onAssociationDeleted);
  function onAssociationDeleted(data) {
    if (data) {
      showAlert(capitalize(t('dialogs:order-updated')), 'success');
      deleteAssociationResponse.reset();
    }
  }

  const { deleteEntry, deleteEntryResponse } = useDeleteEntry(onEntryDeleted);
  function onEntryDeleted(data) {
    if (data) {
      showAlert(capitalize(t('dialogs:order-updated')), 'success');
      deleteEntryResponse.reset();
    }
  }

  const { mutate: deleteLink, ...deleteLinkResponse } = useDeleteOrderLedgerLink({
    queryConfig: {
      onSuccess: (data) => {
        if (data) {
          setAccounting(sortedAccounting(data.deleteOrderLedgerLink.accounting || []));
          showAlert(capitalize(t('dialogs:order-updated')), 'success');
          deleteLinkResponse.reset();
        }
      },
    },
  });

  useEffect(() => {
    if (deleteAssociationResponse.isLoading || deleteLinkResponse.isLoading) {
      showAlert('Deleting...', 'info');
    }
  }, [deleteAssociationResponse.isLoading, deleteLinkResponse.isLoading]);

  return {
    deleteAssociation,
    deleteEntry,
    deleteLink,
  };
};

export default useMutationsAccounting;
